// This file is auto-generated by @hey-api/openapi-ts

export type UserRole = {
    exp_user_role: string;
};

export type UserMark = {
    block_name: string;
    edited_on?: string;
    marks: Array<(string)>;
};

export type GeoAccessPolicy = {
    geo_access_levels: Array<(string)>;
};

export type User = {
    id?: (number) | null;
    user_role?: UserRole;
    is_authenticated?: boolean;
    email?: string;
    phone?: string;
    full_name?: (string) | null;
    name?: (string) | null;
    avatar?: (string) | null;
    email_md5?: string;
    is_guide?: boolean;
    is_moderator?: boolean;
    is_partner?: boolean;
    orders_count_guide?: number;
    orders_count_traveler?: number;
    exp_count?: number;
    exp_count_published?: number;
    updated_orders_count?: {
        all?: number;
        as_guide?: number;
        as_traveler?: number;
    } | null;
    is_guide_promo_available?: (boolean) | null;
    geo_access_policy?: GeoAccessPolicy;
    user_marks?: Array<UserMark>;
    exp_token?: string;
};

export type UserFeatures = {
    guide_price_adjustment?: boolean;
    travelagent_bar?: string;
    partner_header?: string;
    recaptcha?: {
        is_enabled?: boolean;
        v2_secret?: string;
        v3_secret?: string;
    };
    can_impersonate?: boolean;
    under_impersonalization?: boolean;
};

export type UserSession = {
    device_id?: string;
};

export type UserConfig = {
    facebook_app_id?: string;
    facebook_page_id?: string;
};

export type GetUserResponse = {
    conf?: UserConfig;
    user?: User;
    url?: string;
    features?: UserFeatures;
    session?: UserSession;
};

export type SubscribeRequest = {
    email: string;
    source: string;
    subscription: {
        channel: string;
        name: string;
        user_type: string;
    };
};

/**
 * * `guide` - Гид
 * * `traveler` - Путешественник
 * * `support` - Поддержка
 */
export type UserRoleEnum = 'guide' | 'traveler' | 'support';

/**
 * * `guide` - Гид
 * * `traveler` - Путешественник
 * * `support` - Поддержка
 */
export const UserRoleEnum = {
    GUIDE: 'guide',
    TRAVELER: 'traveler',
    SUPPORT: 'support'
} as const;

export type NullEnum = unknown;

/**
 * Ответ на запрос для seo информации для города по slug и выбранному тэгу
 */
export type SeoRequestByCitySlugAndTag = {
    seo?: Seo;
    faq?: Faq;
    city_rating?: number;
    review_count?: number;
    price_ranges?: {
        [key: string]: unknown;
    };
};

/**
 * Seo информация для города по slug и выбранному тэгу
 */
export type Seo = {
    slug?: string;
    title?: string;
    description?: string;
    h1?: string;
    h2?: string;
    text?: string;
    canonical_url?: string;
    noindex?: string;
    attachments?: Array<unknown>;
};

/**
 * Список вопросов для seo-блока
 */
export type Faq = {
    slug?: string;
    title?: string;
    indexable?: boolean;
    items?: Array<FaqQuestion>;
};

/**
 * Описание вопроса для блока FAQ seo
 */
export type FaqQuestion = {
    question?: string;
    answer?: string;
    links?: Array<FaqQuestionLink>;
};

/**
 * Описание ссылок для вопроса
 */
export type FaqQuestionLink = {
    text?: string;
    url?: string;
};

/**
 * Ответ на запрос для seo информации тура по id тура/тэга
 */
export type SeoRequestForTourById = {
    seo?: Seo;
    faq?: Faq;
};

/**
 * Ответ на запрос для информации по городу по slug
 */
export type CityInfo = {
    id?: number;
    name_ru?: string;
    name_1_ru?: string;
    name_5_ru?: string;
    name_en?: string;
    iata?: string;
    country?: CityInfoCountry;
    experience_count?: number;
    tours_count?: number;
    excursions_count?: number;
    about_obj_phrase?: string;
    in_obj_phrase?: string;
    from_obj_phrase?: string;
    across_obj_phrase?: string;
    name_prepositional?: string;
    url?: string;
    image?: CityInfoImage;
    utc_offset?: number;
    guides_count?: number;
    slug?: string;
};

/**
 * Описание ифнормации о стране для города
 */
export type CityInfoCountry = {
    id?: number;
    name_ru?: string;
    name_2_ru?: string;
    name_5_ru?: string;
    name_en?: string;
    currency?: string;
    in_obj_phrase?: string;
    about_obj_phrase?: string;
    across_obj_phrase?: string;
    experience_count?: number;
    tours_count?: number;
    guides_count?: number;
    url?: string;
    region?: string;
    slug?: string;
    cover_image_url?: (string) | null;
    geo_access_level?: string;
};

/**
 * Описание объекта изображений для города
 */
export type CityInfoImage = {
    cover?: string;
    thumbnail?: string;
};

/**
 * Ответ на запрос для информации по стране по slug
 */
export type CountryInfo = {
    id?: number;
    name_ru?: string;
    name_2_ru?: string;
    name_5_ru?: string;
    name_en?: string;
    currency?: string;
    in_obj_phrase?: string;
    about_obj_phrase?: string;
    across_obj_phrase?: string;
    experience_count?: number;
    tours_count?: number;
    guides_count?: number;
    url?: string;
    region?: string;
    code?: string;
    slug?: string;
    cover_image_url?: string;
    geo_access_level?: string;
};

/**
 * Ответ на запрос для информации городов из страны по slug
 */
export type CountryFromCitiesInfo = {
    id?: number;
    slug?: string;
    name_ru?: string;
    in_obj_phrase?: string;
    across_obj_phrase?: string;
    from_obj_phrase?: string;
    to_obj_phrase?: string;
};

export type GetCitiesAroundResponse = Array<WebCitiesAround>;

export type GetCitiesRegionResponse = {
    tours?: GetCitiesRegionItemResponse;
};

export type GetCitiesToursByRegionResponse = Array<{
    title: string;
    slug: string;
}>;

export type GetCalendarEventsChipsResponse = {
    public_holidays?: Array<GetCalendarEventChipsResponse>;
    months?: Array<GetCalendarEventChipsResponse>;
    seasons?: Array<GetCalendarEventChipsResponse>;
};

export type GetListingBannersResponse = Array<GetListingBannersItemResponse>;

export type GetListingBannersItemResponse = {
    id: number;
    key: string;
    template: string;
    banner_params: GetListingBannersItemBannerParamsResponse;
};

export type GetCalendarEventChipsResponse = {
    name: string;
    start_date: string;
    end_date: string;
};

export type GetListingBannersItemBannerParamsResponse = {
    background?: string;
    description?: string;
    image_main?: string;
    image_sub?: string;
    image?: string;
    title?: string;
    button?: ListingBannersButton;
    tags?: Array<ListingBannersButton>;
};

export type ListingBannersButton = {
    link: string;
    text: string;
    link_params?: {
        [key: string]: unknown;
    };
};

export type GetCitiesRegionItemResponse = {
    region_type: string;
    slug: string;
    in_obj_phrase: string;
    to_obj_phrase: string;
    image: string;
};

export type WebCitiesAround = {
    /**
     * Формат: латиницей, первые буквы отдельных слов с большой буквы, а вместо пробелов знак подчеркивания. Используется для URL страницы города. Например: Kuala Lumpur → Kuala_Lumpur, Nizhniy Novgorod → Nizhny_Novgorod
     */
    slug?: (string) | null;
    name_ru: string;
    name_en?: string;
    experience_count: number;
    readonly excursions_count?: number;
    tours_count?: number;
    attractions_count?: number;
    readonly url?: string;
    image?: CityInfoImage;
};

/**
 * Ответ на запрос для информации по регионам по стране
 */
export type RegionsInCountryInfo = {
    count?: number;
    next?: string;
    previous?: string;
    results?: Array<RegionsInCountryItems>;
};

/**
 * Массив регионов по стране
 */
export type RegionsInCountryItems = {
    id: number;
    name?: string;
    name_2_ru?: string;
    name_5_ru?: string;
    russian_word_in?: string;
    cover_image_url?: string;
    image?: {
        thumbnail?: string;
        cover?: string;
    };
    slug?: string;
    experience_count?: number;
    tours_count?: number;
    review_count?: number;
    tours_review_count?: number;
    guides_count?: number;
    in_obj_phrase?: string;
    about_obj_phrase?: string;
    across_obj_phrase?: string;
    countries?: Array<RegionInfoCountry>;
    from_cities?: Array<RegionInfoFromCitiesItem>;
    min_price_tours?: number;
};

/**
 * Ответ на запрос для информации по региону по slug
 */
export type RegionInfo = {
    id?: number;
    name?: string;
    name_2_ru?: string;
    name_5_ru?: string;
    russian_word_in?: string;
    cover_image_url?: string;
    slug?: string;
    experience_count?: number;
    tours_count?: number;
    review_count?: number;
    tours_review_count?: number;
    guides_count?: number;
    in_obj_phrase?: string;
    about_obj_phrase?: string;
    across_obj_phrase?: string;
    countries?: Array<RegionInfoCountry>;
    from_cities?: Array<RegionInfoFromCitiesItem>;
    min_price_tours?: number;
};

/**
 * Описание ифнормации о стране для региона
 */
export type RegionInfoCountry = {
    id?: number;
    name_ru?: string;
    name_2_ru?: string;
    name_5_ru?: string;
    name_en?: string;
    currency?: string;
    in_obj_phrase?: string;
    about_obj_phrase?: string;
    across_obj_phrase?: string;
    experience_count?: number;
    tours_count?: number;
    guides_count?: number;
    url?: string;
    region?: string;
};

/**
 * Город, откуда доступен данный тур
 */
export type RegionInfoFromCitiesItem = {
    id?: number;
    slug?: string;
    name_ru?: string;
    in_obj_phrase?: string;
    across_obj_phrase?: string;
    from_obj_phrase?: string;
    to_obj_phrase?: string;
};

/**
 * Ответ на запрос списка гидов
 */
export type GetGuideRequest = {
    count?: number;
    next?: (string) | null;
    previous?: (string) | null;
    results?: Array<Guide>;
};

/**
 * Информация о гиде
 */
export type Guide = {
    id: number;
    first_name: string;
    url: string;
    avatar: GuideAvatar;
    rating?: number;
    review_count?: number;
    rate_count?: number;
    avg_reaction_delay?: number;
    avg_reaction_delay_display?: GuideAvgReactionDelayDisplay;
    links?: GuideLinks;
    guide_type?: string;
    is_guide_since?: string;
    is_licensed_guide?: boolean;
    city: GuideCity;
    description: string;
    determination?: string;
    determination_with_links?: string;
    exp_count_published?: number;
    number_of_persons_paid?: number;
    tours_count_published?: number;
    guide_legal_info?: GuideLegalInfo;
};

/**
 * Аватар гида
 */
export type GuideAvatar = {
    medium: string;
    small?: string;
};

/**
 * Отображение среднего времени реакции гида
 */
export type GuideAvgReactionDelayDisplay = {
    nominative?: string;
    accusative?: string;
    genitive?: string;
};

/**
 * Ссылки гида (на отзывы)
 */
export type GuideLinks = {
    reviews?: string;
};

/**
 * Город гида
 */
export type GuideCity = {
    id?: number;
    name_ru?: string;
    name_1_ru?: string;
    name_5_ru?: string;
    name_en?: string;
    iata?: string;
    country?: GuideCityCountry;
    experience_count?: number;
    tours_count?: number;
    excursions_count?: number;
    about_obj_phrase?: string;
    in_obj_phrase?: string;
    from_obj_phrase?: string;
    across_obj_phrase?: string;
    name_prepositional?: string;
    url?: string;
    image?: GuideCityImage;
    utc_offset?: number;
    guides_count?: number;
    slug?: string;
};

/**
 * Описание страны в объекте города гида
 */
export type GuideCityCountry = {
    id?: number;
    name_ru?: string;
    name_2_ru?: string;
    name_5_ru?: string;
    name_en?: string;
    currency?: string;
    in_obj_phrase?: string;
    about_obj_phrase?: string;
    across_obj_phrase?: string;
    experience_count?: number;
    tours_count?: number;
    guides_count?: number;
    url?: string;
    region?: string;
};

/**
 * Изображения для гоода гида
 */
export type GuideCityImage = {
    cover?: string;
    thumbnail?: string;
};

/**
 * Юридическая информация о гиде
 */
export type GuideLegalInfo = {
    entity_type?: string;
    legal_name?: string;
    work_country?: string;
    inn?: string;
    ogrn?: (string) | null;
};

/**
 * Ответ на запрос списка отзывов
 */
export type GetReviewsRequest = {
    count?: number;
    next?: (string) | null;
    previous?: (string) | null;
    results?: Array<Review>;
};

/**
 * Информация об отзыве
 */
export type Review = {
    id?: number;
    name?: string;
    avatar?: ReviewAvatar;
    created_at?: string;
    created_on?: string;
    created_on_dt?: string;
    rating?: number;
    text?: string;
    guide_reply?: ReviewReplyInfo;
    experience?: ReviewExperience;
    traveler_level?: number;
    photos?: Array<ReviewPhoto>;
    is_showing_processing_photos?: boolean;
};

/**
 * Аватар для отзыва
 */
export type ReviewAvatar = {
    small?: string;
    medium?: string;
};

/**
 * Экспириенс к которому прикреплен даннный отзыв
 */
export type ReviewExperience = {
    id?: number;
    title?: string;
    format?: string;
    type?: string;
    url?: string;
    is_bookable?: boolean;
    is_visible?: boolean;
};

/**
 * Ответ гида на отзыв
 */
export type ReviewReplyInfo = {
    name?: string;
    text?: string;
    type?: string;
    avatar?: {
        medium?: string;
        small?: string;
    };
} | null;

/**
 * Фото в отзыве
 */
export type ReviewPhoto = {
    id?: number;
    small?: string;
    medium?: string;
    thumbnail_s?: string;
};

/**
 * Получить спсиок тэгов региона
 */
export type GetRegionTagsRequest = {
    count?: number;
    next?: (string) | null;
    previous?: (string) | null;
    results?: Array<RegionTag>;
};

/**
 * Описание тэга для региона
 */
export type RegionTag = {
    id?: number;
    slug: string;
    name?: string;
    category?: string;
    urls?: RegionTagUrls;
    images?: RegionTagImages;
    flags?: RegionTagFlags;
    counters?: RegionTagCounters;
};

/**
 * Ссылки у тэга региона
 */
export type RegionTagUrls = {
    tours?: string;
    excursions?: string;
};

/**
 * Ссылки у тэга страны
 */
export type CountryTagUrls = {
    tours?: string;
    excursions?: string;
};

/**
 * Изображения у тэга региона
 */
export type RegionTagImages = {
    cover?: RegionTagImagesCover;
    icon?: RegionTagImagesIcon;
};

/**
 * Варианты изображений у тэга региона
 */
export type RegionTagImagesCover = {
    thumbnail?: string;
    medium?: string;
};

/**
 * Варианты иконок у тэга региона
 */
export type RegionTagImagesIcon = {
    thumbnail?: string;
    medium?: string;
} | null;

/**
 * Флаги у тэга региона
 */
export type RegionTagFlags = {
    is_hidden?: boolean;
    is_common?: boolean;
    is_attraction?: boolean;
    is_auto?: boolean;
    is_seo_only?: boolean;
    is_tours_included?: boolean;
};

/**
 * Количество отзывов, туров, экскурсий у тэга региона
 */
export type RegionTagCounters = {
    excursions_count?: number;
    tours_count?: number;
    review_count?: number;
};

/**
 * Получить спсиок тэгов города
 */
export type GetCityTagsRequest = {
    count?: number;
    next?: (string) | null;
    previous?: (string) | null;
    results?: Array<CityTag>;
};

/**
 * Описание тэга города
 */
export type CityTag = {
    id?: number;
    slug: string;
    name?: string;
    category?: string;
    urls?: CityTagUrls;
    redirect?: string;
    images?: CityTagImages;
    flags?: CityTagFlags;
    counters?: CityTagCounters;
};

/**
 * Ссылки у тэга города
 */
export type CityTagUrls = {
    excursions?: string;
    tours?: string;
};

/**
 * Изображения у тэга города
 */
export type CityTagImages = {
    cover?: CityTagImagesCover;
    icon?: CityTagImagesIcon;
};

/**
 * Варианты изображений у тэга города
 */
export type CityTagImagesCover = {
    thumbnail?: string;
    medium?: string;
};

/**
 * Варианты иконок у тэга города
 */
export type CityTagImagesIcon = {
    thumbnail?: string;
    medium?: string;
} | null;

/**
 * Флаги у тэга города
 */
export type CityTagFlags = {
    is_hidden?: boolean;
    is_common?: boolean;
    is_attraction?: boolean;
    is_auto?: boolean;
    is_seo_only?: boolean;
    is_tours_included?: boolean;
};

/**
 * Количество отзывов, туров, экскурсий, экспириенсов у тэга города
 */
export type CityTagCounters = {
    experience_count?: number;
    excursions_count?: number;
    tours_count?: number;
    review_count?: number;
};

/**
 * Получить спсиок тэгов страны
 */
export type GetCountryTagsRequest = {
    count?: number;
    next?: (string) | null;
    previous?: (string) | null;
    results?: Array<CountryTag>;
};

/**
 * Получить SEO инфу по тагу страны
 */
export type GetCountrySeoTagRequest = {
    faq?: {
        [key: string]: unknown;
    };
    seo?: SeoCountryTag;
};

/**
 * Получить SEO инфу по тагу региона
 */
export type GetRegionSeoTagRequest = {
    faq?: {
        [key: string]: unknown;
    };
    seo?: SeoRegionTag;
};

/**
 * Описание тэга страны
 */
export type CountryTag = {
    id: number;
    slug?: string;
    tag_id?: number;
    tag_slug: string;
    country_slug?: string;
    name?: string;
    category?: string;
    images?: CountryTagImages;
    flags?: CountryTagFlags;
    counters?: CountryTagCounters;
    urls?: CountryTagUrls;
};

/**
 * SEO Описание тэга страны
 */
export type SeoCountryTag = {
    canonical_url?: string;
    description?: string;
    h1: string;
    h2?: string;
    noindex?: boolean;
    slug?: string;
    text?: string;
    title?: string;
};

/**
 * SEO Описание тэга региона
 */
export type SeoRegionTag = {
    canonical_url?: string;
    description?: string;
    h1: string;
    h2?: string;
    noindex?: boolean;
    slug?: string;
    text?: string;
    title?: string;
};

/**
 * Изображения у тэга страны
 */
export type CountryTagImages = {
    cover?: CountryTagImagesCover;
    icon?: CountryTagImagesIcon;
};

/**
 * Варианты изображений у тэга страны
 */
export type CountryTagImagesCover = {
    thumbnail?: string;
    medium?: string;
} | null;

/**
 * Варианты иконок у тэга страны
 */
export type CountryTagImagesIcon = {
    thumbnail?: string;
    medium?: string;
} | null;

/**
 * Флаги у тэга страны
 */
export type CountryTagFlags = {
    is_hidden?: boolean;
    is_common?: boolean;
    is_attraction?: boolean;
    is_auto?: boolean;
    is_seo_only?: boolean;
    is_tours_included?: boolean;
};

/**
 * Количество туров у тэга страны
 */
export type CountryTagCounters = {
    tours_count?: number;
    excursions_count?: number;
};

/**
 * Полезные статьи с сопровождающей информацией
 */
export type GetRelatedArticles = {
    count?: number;
    next?: number;
    previous?: number;
    results?: Array<RelatedArticle>;
};

/**
 * Статья из блока полезных статей
 */
export type RelatedArticle = {
    created_at?: string;
    id?: number;
    intro?: string;
    lightbox_photo_url?: string;
    published_at?: string;
    reading_time?: number;
    slug?: string;
    tagline?: string;
    tags?: Array<(number)>;
    thumb_photo_url?: string;
    title?: string;
    type?: string;
    updated_at?: string;
    url?: string;
};

/**
 * Запрос обратной связи туров
 */
export type ChooseTourRequest = {
    page_url?: string;
    phone?: string;
};

export type ActivityTypesResponse = Array<ActivityType>;

export type ActivityType = {
    id?: number;
    name?: string;
    slug?: string;
    category?: string;
};

export type MovementTypesResponse = {
    movement_type?: Array<MovementType>;
    movement_type_group?: Array<MovementTypeGroup>;
    movement_type_group_map?: {
        [key: string]: Array<(string)>;
    };
};

export type MovementType = {
    str?: string;
    label?: string;
    label_phrase?: string;
};

export type MovementTypeGroup = {
    str?: string;
    label?: string;
};

export type ExperienceAggregations = {
    /**
     * Агрегированные данные по тегам
     */
    tags?: {
        [key: string]: (number);
    };
    /**
     * Агрегированные данные по типам активности
     */
    tour_activities?: {
        [key: string]: (number);
    };
    /**
     * Набор агрегированных данных по тегам
     */
    tags_set?: {
        [key: string]: (number);
    };
    /**
     * Типы экспириенсов
     */
    type?: {
        private?: number;
        group?: number;
        tour?: number;
        ticket?: number;
        transfer_service?: number;
    };
    /**
     * Кастомные типы экспириенсов
     */
    custom_type?: {
        minigroup?: {
            total?: number;
            type?: {
                group?: number;
            };
        };
    };
    /**
     * Типы передвижения
     */
    movement_type?: {
        [key: string]: (number);
    };
    /**
     * Информация о ценах
     */
    price?: {
        persons_count?: number;
        histogram_interval?: number;
        histogram?: {
            [key: string]: (number);
        };
        defaultHistogram?: {
            [key: string]: (number);
        };
        range?: [
            number,
            number
        ];
        defaultRange?: [
            number,
            number
        ];
    };
    /**
     * Цены в валюте отображения
     */
    display_prices?: {
        /**
         * ISO-код валюты отображения
         */
        currency?: string;
        persons_count?: number;
        histogram_interval?: number;
        histogram?: {
            [key: string]: (number);
        };
        range?: [
            number,
            number
        ];
    };
    /**
     * Продолжительность экспириенсов
     */
    duration?: {
        [key: string]: (number);
    };
    /**
     * Диапазон дат
     */
    date?: [
        (Date | number),
        (Date | number)
    ];
    /**
     * Доступность экспириенсов
     */
    availability?: {
        [key: string]: (number);
    };
};

/**
 * Пагинированный список рекомендаций с метаданными алгоритма (EXP-27331)
 */
export type GetExperiencesRecommendationsResponse = GetExperiencesRequest & {
    recommendation_algorithm_id: string;
    recommendation_algorithm_name?: (string) | null;
    recommendation_algorithm_type?: (string) | null;
};

/**
 * Ответ на запрос для получения всех экспириенсов
 */
export type GetExperiencesRequest = {
    count?: number;
    next?: (string) | null;
    previous?: (string) | null;
    results?: Array<Experience>;
};

/**
 * Элемент массива экспириенсов
 */
export type Experience = {
    id: number;
    title?: string;
    tagline?: string;
    annotation?: string;
    url?: string;
    type?: string;
    format?: string;
    grade?: string;
    movement_type?: string;
    schedule_type?: string;
    status?: string;
    exp_status?: number;
    is_instant_booking?: boolean;
    is_new?: boolean;
    max_persons?: number;
    duration?: number;
    price: ExperiencePrice;
    display_price?: ExperiencePrice;
    rating?: number;
    visitors_count?: number;
    review_count?: number;
    pause_finish_date?: (string) | null;
    pause_reason?: (string) | null;
    cancel_finish_date?: (string) | null;
    cancel_reason?: (string) | null;
    additional_info?: string;
    comfort_level_info?: string;
    price_included_description?: string;
    price_not_included_description?: string;
    geo_access_level?: string;
    geo?: ExperienceGeo;
    guide?: ExperienceGuide;
    guide_can_resume?: boolean;
    is_legal?: boolean;
    has_non_refundable_part?: boolean;
    schedule?: ExperienceSchedule;
    photos?: Array<ExperiencePhotos>;
    is_paid?: boolean;
    /**
     * Is under sanctions
     */
    is_under_sanctions?: boolean;
    labels?: Array<PromoLabel>;
};

/**
 * Лейблы платного продвижения
 */
export type PromoLabel = {
    type?: string;
    title?: string;
};

/**
 * Описание поля photos у experience
 */
export type ExperiencePhotos = {
    medium?: string;
    thumbnail?: string;
    type?: string;
};

/**
 * Описание поля schedule у experience
 */
export type ExperienceSchedule = {
    upcoming_events?: Array<(string)>;
};

/**
 * Описание поля guide у experience
 */
export type ExperienceGuide = {
    avatar?: {
        medium?: string;
        small?: string;
    };
    avg_reaction_delay?: number;
    avg_reaction_delay_display?: {
        accusative?: string;
        genitive?: string;
        nominative?: string;
    };
    date_joined?: string;
    date_start_work?: string;
    description?: string;
    exp_count_published?: number;
    id?: number;
    first_name?: string;
    is_licensed?: boolean;
    orders_count?: number;
    rate_count?: number;
    rating?: number;
    review_count?: number;
    type?: string;
    url?: string;
    visitors_count?: number;
};

/**
 * Описание поля price у experience
 */
export type ExperiencePrice = {
    value?: number;
    currency?: 'EUR' | 'GBP' | 'RUB' | 'THB' | 'USD';
    currency_rate?: number;
    per_group?: {
        value?: number;
        without_discount?: number;
    };
    per_person?: Array<ExperiencePricePerPersonItem>;
    price_from?: boolean;
    unit_string?: string;
    max_persons_range?: string;
    value_string?: string;
    discount?: {
        value: number;
        expiration_date?: string;
        expiration_text?: string;
        original_price?: number;
    };
};

export type currency = 'EUR' | 'GBP' | 'RUB' | 'THB' | 'USD';

export const currency = {
    EUR: 'EUR',
    GBP: 'GBP',
    RUB: 'RUB',
    THB: 'THB',
    USD: 'USD'
} as const;

/**
 * Элемент массива цены за человека
 */
export type ExperiencePricePerPersonItem = {
    id?: number;
    title?: string;
    is_default?: boolean;
    value?: number;
    without_discount?: number;
};

/**
 * Описание объекта с гео данными в экспириенсе
 */
export type ExperienceGeo = {
    city?: Array<ExperienceGeoItem>;
    country?: Array<ExperienceGeoItem>;
};

/**
 * Элемент массива города/страны в гео объекте экспириенса
 */
export type ExperienceGeoItem = {
    id?: number;
    slug?: string;
    name?: string;
    name_prepositional?: string;
    in_obj_phrase?: string;
    from_obj_phrase?: string;
    across_obj_phrase?: string;
    is_main_city?: boolean;
};

export type GetRelatedExperiencesResponse = Array<{
    type?: string;
    link?: string;
    title?: string;
    subtitle?: string;
    experiences?: Array<Experience>;
    exp_total_count?: number;
    is_auto?: boolean;
    extra_data?: {
        tag_id?: (number) | null;
        tag_slug?: (string) | null;
    };
}>;

export type DisplayCurrency = {
    /**
     * ISO-код валюты
     */
    iso_code: string;
    /**
     * Название валюты
     */
    name: string;
    /**
     * Символ валюты
     */
    symbol: string;
};

export type GetExperiencesCountResponse = {
    count?: number;
};

export type GetUserResponse2 = (GetUserResponse);

export type GetUserError = unknown;

export type GetSeoByCityTagData = {
    query?: {
        ids?: string;
    };
};

export type GetSeoByCityTagResponse = (SeoRequestByCitySlugAndTag);

export type GetSeoByCityTagError = unknown;

export type GetSeoByCitySlugData = {
    query?: {
        ids?: string;
    };
};

export type GetSeoByCitySlugResponse = (SeoRequestByCitySlugAndTag);

export type GetSeoByCitySlugError = unknown;

export type GetTourSeoByIdData = {
    path: {
        tourType: string;
    };
    query?: {
        ids?: string;
    };
};

export type GetTourSeoByIdResponse = (SeoRequestForTourById);

export type GetTourSeoByIdError = unknown;

export type GetSeoFromCityToRegionData = {
    query?: {
        ids?: string;
    };
};

export type GetSeoFromCityToRegionResponse = (SeoRequestForTourById);

export type GetSeoFromCityToRegionError = unknown;

export type GetSeoFromCityToCountryData = {
    query?: {
        ids?: string;
    };
};

export type GetSeoFromCityToCountryResponse = (SeoRequestForTourById);

export type GetSeoFromCityToCountryError = unknown;

export type GetCityInfoBySlugData = {
    path: {
        citySlug: string;
    };
};

export type GetCityInfoBySlugResponse = (CityInfo);

export type GetCityInfoBySlugError = unknown;

export type GetRegionsInCountryData = {
    query: {
        all?: string;
        country__slug: string;
        has_tours?: string;
        sorting?: string;
    };
};

export type GetRegionsInCountryResponse = (RegionsInCountryInfo);

export type GetRegionsInCountryError = unknown;

export type GetRegionInfoBySlugData = {
    path: {
        regionSlug: string;
    };
};

export type GetRegionInfoBySlugResponse = (RegionInfo);

export type GetRegionInfoBySlugError = unknown;

export type GetCountryInfoBySlugData = {
    path: {
        countrySlug: string;
    };
};

export type GetCountryInfoBySlugResponse = (CountryInfo);

export type GetCountryInfoBySlugError = unknown;

export type GetCountryFromCitiesInfoData = {
    path: {
        countrySlug: string;
    };
};

export type GetCountryFromCitiesInfoResponse = (Array<CountryFromCitiesInfo>);

export type GetCountryFromCitiesInfoError = unknown;

export type GetGuidesData = {
    query?: {
        /**
         * slug города
         */
        city__slug?: string;
        /**
         * Тип экспириенса (excursion,tour,ticket,transfer_service)
         */
        exp_types?: 'excursion' | 'tour' | 'ticket' | 'transfer_service';
        /**
         * Количество отзывов
         */
        page_size?: number;
        /**
         * slug региона
         */
        region__slug?: string;
        /**
         * Вариант сортировки:
         * '-review_rated_count' - — по числу отзывов с оценками (по убыванию)
         * '-review_rating' - по рейтингу Вилсона на основе оценок отзывов (по убыванию)
         * 'random' - cлучайно
         */
        sorting?: '-review_rated_count' | '-review_rating' | 'random';
        /**
         * Минимальное количество туров
         */
        tours_count_min?: number;
    };
};

export type GetGuidesResponse = (GetGuideRequest);

export type GetGuidesError = unknown;

export type GetReviewsData = {
    query?: {
        /**
         * slug города
         */
        city__slug?: string;
        /**
         * slug страны
         */
        country__slug?: string;
        /**
         * Тип экспириенса (group/private/ticket/tour/transfer_service/etc.)
         */
        exp_type?: string;
        /**
         * Только длинные отзывы (длина >= 140 символов)
         */
        is_long?: 1;
        /**
         * Максимальное количество отзывов
         */
        limit?: number;
        /**
         * Количество озывов в page
         */
        page_size?: number;
        /**
         * Максимальная оценка
         */
        rate_max?: number;
        /**
         * Минимальная оценка
         */
        rate_min?: number;
        /**
         * slug региона
         */
        region__slug?: string;
        /**
         * Отзывы только на экспириенсы в указанных рубриках (slug через запятую, экспириенс должен попадать во все указанные рубрики, а не в одну из)
         */
        tag__slug?: string;
    };
};

export type GetReviewsResponse = (GetReviewsRequest);

export type GetReviewsError = unknown;

export type GetRegionTagsData = {
    query?: {
        /**
         * Количество тэгов на странице
         */
        page_size?: number;
        /**
         * slug региона
         */
        region__slug?: string;
        /**
         * Сортировка: '-popularity' - по популярности (по умолчанию)
         * '-excursions_count' - по количесву экскурсий в рубрике
         * '-tours_count' - по количеству туров в рубрике
         */
        sorting?: '-popularity' | '-excursions_count' | '-tours_count';
    };
};

export type GetRegionTagsResponse = (GetRegionTagsRequest);

export type GetRegionTagsError = unknown;

export type GetSeoRegionTagData = {
    query: {
        /**
         * slug тега
         */
        ids: string;
    };
};

export type GetSeoRegionTagResponse = (GetRegionSeoTagRequest);

export type GetSeoRegionTagError = unknown;

export type GetCityTagsData = {
    query?: {
        /**
         * slug города
         */
        city__slug?: string;
        /**
         * Количество тэгов на странице
         */
        page_size?: number;
        /**
         * Сортировка: '-popularity' - по популярности (по умолчанию)
         * '-excursions_count' - по количесву экскурсий в рубрике
         * '-tours_count' - по количеству туров в рубрике
         * 'ranking_mab' - сортировка MAB
         */
        sorting?: '-popularity' | '-excursions_count' | '-tours_count' | 'ranking_mab';
    };
};

export type GetCityTagsResponse = (GetCityTagsRequest);

export type GetCityTagsError = unknown;

export type GetCountryTagsData = {
    query?: {
        /**
         * slug страны
         */
        country__slug?: string;
    };
};

export type GetCountryTagsResponse = (GetCountryTagsRequest);

export type GetCountryTagsError = unknown;

export type GetSeoCountryTagData = {
    query: {
        /**
         * slug тега
         */
        ids: string;
    };
};

export type GetSeoCountryTagResponse = (GetCountrySeoTagRequest);

export type GetSeoCountryTagError = unknown;

export type GetRelatedArticlesByLocationSlugData = {
    query?: {
        /**
         * Slug города
         */
        city__slug?: string;
        /**
         * Slug страны
         */
        country__slug?: string;
        /**
         * Slug региона
         */
        region__slug?: string;
    };
};

export type GetRelatedArticlesByLocationSlugResponse = (GetRelatedArticles);

export type GetRelatedArticlesByLocationSlugError = unknown;

export type GetCitiesAroundData = {
    path: {
        /**
         * Уникальный идентификатор города
         */
        cityId: number;
    };
};

export type GetCitiesAroundResponse2 = (GetCitiesAroundResponse);

export type GetCitiesAroundError = unknown;

export type GetCitiesRegionData = {
    path: {
        /**
         * Уникальный идентификатор города
         */
        citySlug: string;
    };
};

export type GetCitiesRegionResponse2 = (GetCitiesRegionResponse);

export type GetCitiesRegionError = unknown;

export type GetListingBannersData = {
    query?: {
        /**
         * тип проживания
         */
        accommodation_type?: string;
        /**
         * уровень сложности
         */
        activity_level_category?: string;
        /**
         * выводить ли присотановденные или нет
         */
        bookable?: string;
        /**
         * Разрешено ли с детьми
         */
        children_allowed?: boolean;
        /**
         * slug города
         */
        city__slug?: string;
        /**
         * уровень комфорта
         */
        comfort_type?: string;
        /**
         * slug страны
         */
        country__slug?: string;
        /**
         * длительность экскурсии (интервал)
         */
        duration_interval?: string;
        /**
         * дата "по" включительно в формате YYYY-MM-DD
         */
        end_date?: string;
        /**
         * максимальная длительность (в часах)
         */
        end_duration?: number;
        /**
         * максимальная стоимость
         */
        end_price?: number;
        /**
         * фильтр по формату экспириенса (experience/activity/waterwalk/photosession/etc.)
         */
        exp_format?: string;
        /**
         * кол-во экспириенсов в ответе на запрос
         */
        limit?: number;
        /**
         * фильтр по типу передвижения (foot/car/bicycle/watership/etc.)
         */
        movement_type?: string;
        /**
         * Отступ по кол-ву экспириенсов
         */
        offset?: number;
        /**
         * текущая страница
         */
        page?: number;
        /**
         * фильтр по приостановленным экспириенсам
         */
        paused?: string;
        /**
         * Количество человек
         */
        persons_count?: number;
        /**
         * кол-во фотографий
         */
        photos_count?: number;
        /**
         * формат цены
         */
        price_format?: 'travelers';
        /**
         * Эксперимент с сортировкой Э (EXP-26049)
         */
        ranking_field?: string;
        /**
         * slug региона
         */
        region__slug?: string;
        /**
         * сортировка
         */
        sorting?: string;
        /**
         * дата "от" включительно в формате YYYY-MM-DD
         */
        start_date?: string;
        /**
         * минимальная длительность (в часах)
         */
        start_duration?: number;
        /**
         * минимальная стоимость
         */
        start_price?: number;
        /**
         * временной интервал экскурсии
         */
        start_time_interval?: string;
        /**
         * bilety-v-muzei
         */
        tag__slugs?: string;
        /**
         * фильтр по типу активности (pohod/splav/ski-and-snowboard/yahting/etc.)
         */
        tour_activity_slugs?: string;
        /**
         * формат экскурсий
         */
        type?: string;
    };
};

export type GetListingBannersResponse2 = (GetListingBannersResponse);

export type GetListingBannersError = unknown;

export type PostChooseTourFormDataData = {
    /**
     * Choose Tour Form Request
     */
    body: ChooseTourRequest;
};

export type PostChooseTourFormDataResponse = (unknown);

export type PostChooseTourFormDataError = (unknown);

export type GetMovementTypesResponse = (MovementTypesResponse);

export type GetMovementTypesError = unknown;

export type GetToursActivitiesResponse = (ActivityTypesResponse);

export type GetToursActivitiesError = unknown;

export type GetExperienceAggregationsData = {
    query?: {
        /**
         * Slug города
         */
        city__slug?: string;
        /**
         * Дата "до" включительно в формате YYYY-MM-DD
         */
        end_date?: string;
        /**
         * Максимальная длительность (в часах)
         */
        end_duration?: number;
        /**
         * Конечная цена
         */
        end_price?: number;
        /**
         * Фильтр по формату экспириенса
         */
        exp_format?: string;
        /**
         * Фильтр по типу передвижения
         */
        movement_type?: string;
        /**
         * Текущая страница
         */
        page?: number;
        /**
         * фильтр по приостановленным экспириенсам (true/false/all) ПОЛЕ МОЖЕТ ИЗМЕНИТЬСЯ
         */
        paused?: string;
        /**
         * Количество человек
         */
        persons_count?: number;
        /**
         * Slug региона
         */
        region__slug?: string;
        /**
         * Дата "от" включительно в формате YYYY-MM-DD
         */
        start_date?: string;
        /**
         * Минимальная длительность (в часах)
         */
        start_duration?: number;
        /**
         * Начальная цена
         */
        start_price?: number;
        /**
         * Фильтр по рубрикам
         */
        tag_slugs?: string;
        /**
         * Фильтр по типу экспириенса
         */
        tour?: string;
        /**
         * Фильтр по типу активности
         */
        tour_activity_slugs?: string;
        /**
         * Фильтр по типу экспириенса
         */
        type?: string;
    };
};

export type GetExperienceAggregationsResponse = (ExperienceAggregations);

export type GetExperienceAggregationsError = unknown;

export type GetExperiencesData = {
    query: {
        /**
         * тип проживания
         */
        accommodation_type?: string;
        /**
         * уровень сложности
         */
        activity_level_category?: string;
        /**
         * выводить ли присотановденные или нет
         */
        bookable?: string;
        /**
         * Разрешено ли с детьми
         */
        children_allowed?: boolean;
        /**
         * slug города
         */
        city__slug?: string;
        /**
         * уровень комфорта
         */
        comfort_type?: string;
        /**
         * slug страны
         */
        country__slug?: string;
        /**
         * Валюта отображения цен
         */
        display_currency?: string;
        /**
         * длительность экскурсии (интервал)
         */
        duration_interval?: string;
        /**
         * дата "по" включительно в формате YYYY-MM-DD
         */
        end_date?: string;
        /**
         * максимальная длительность (в часах)
         */
        end_duration?: number;
        /**
         * максимальная стоимость
         */
        end_price?: number;
        /**
         * фильтр по формату экспириенса (experience/activity/waterwalk/photosession/etc.)
         */
        exp_format?: string;
        /**
         * кол-во экспириенсов в ответе на запрос
         */
        limit?: number;
        /**
         * фильтр по типу передвижения (foot/car/bicycle/watership/etc.)
         */
        movement_type?: string;
        /**
         * Отступ по кол-ву экспириенсов
         */
        offset: number;
        /**
         * текущая страница
         */
        page?: number;
        /**
         * позиции платно продвигаемых экспериенсов через запятую, в 0-индексации
         */
        paid_positions?: string;
        /**
         * позиции платно продвигаемых экспериенсов через запятую, в 0-индексации
         */
        paid_positions?: string;
        /**
         * фильтр по приостановленным экспириенсам
         */
        paused?: string;
        /**
         * Количество человек
         */
        persons_count?: number;
        /**
         * кол-во фотографий
         */
        photos_count?: number;
        /**
         * формат цены
         */
        price_format: 'travelers';
        /**
         * Эксперимент с сортировкой Э (EXP-26049)
         */
        ranking_field?: string;
        /**
         * slug региона
         */
        region__slug?: string;
        /**
         * сортировка
         */
        sorting?: string;
        /**
         * дата "от" включительно в формате YYYY-MM-DD
         */
        start_date?: string;
        /**
         * минимальная длительность (в часах)
         */
        start_duration?: number;
        /**
         * минимальная стоимость
         */
        start_price?: number;
        /**
         * временной интервал экскурсии
         */
        start_time_interval?: string;
        /**
         * bilety-v-muzei
         */
        tag__slugs?: string;
        /**
         * фильтр по типу активности (pohod/splav/ski-and-snowboard/yahting/etc.)
         */
        tour_activity_slugs?: string;
        /**
         * формат экскурсий
         */
        type?: string;
    };
};

export type GetExperiencesResponse = (GetExperiencesRequest);

export type GetExperiencesError = unknown;

export type GetExperiencesRecommendationsData = {
    query: {
        /**
         * тип проживания
         */
        accommodation_type?: string;
        /**
         * уровень сложности
         */
        activity_level_category?: string;
        /**
         * выводить ли присотановденные или нет
         */
        bookable?: string;
        /**
         * Разрешено ли с детьми
         */
        children_allowed?: boolean;
        /**
         * slug города
         */
        city__slug?: string;
        /**
         * уровень комфорта
         */
        comfort_type?: string;
        /**
         * slug страны
         */
        country__slug?: string;
        /**
         * Валюта отображения цен
         */
        display_currency?: string;
        /**
         * длительность экскурсии (интервал)
         */
        duration_interval?: string;
        /**
         * дата "по" включительно в формате YYYY-MM-DD
         */
        end_date?: string;
        /**
         * максимальная длительность (в часах)
         */
        end_duration?: number;
        /**
         * максимальная стоимость
         */
        end_price?: number;
        /**
         * фильтр по формату экспириенса (experience/activity/waterwalk/photosession/etc.)
         */
        exp_format?: string;
        /**
         * кол-во экспириенсов в ответе на запрос
         */
        limit?: number;
        /**
         * фильтр по типу передвижения (foot/car/bicycle/watership/etc.)
         */
        movement_type?: string;
        /**
         * Отступ по кол-ву экспириенсов
         */
        offset: number;
        /**
         * текущая страница
         */
        page?: number;
        /**
         * фильтр по приостановленным экспириенсам
         */
        paused?: string;
        /**
         * Количество человек
         */
        persons_count?: number;
        /**
         * кол-во фотографий
         */
        photos_count?: number;
        /**
         * формат цены
         */
        price_format: 'travelers';
        /**
         * slug региона
         */
        region__slug?: string;
        /**
         * дата "от" включительно в формате YYYY-MM-DD
         */
        start_date?: string;
        /**
         * минимальная длительность (в часах)
         */
        start_duration?: number;
        /**
         * минимальная стоимость
         */
        start_price?: number;
        /**
         * временной интервал экскурсии
         */
        start_time_interval?: string;
        /**
         * bilety-v-muzei
         */
        tag__slugs?: string;
        /**
         * формат экскурсий
         */
        type?: string;
    };
};

export type GetExperiencesRecommendationsResponse2 = (GetExperiencesRecommendationsResponse);

export type GetExperiencesRecommendationsError = unknown;

export type GetExperiencesCountData = {
    query: {
        /**
         * тип проживания
         */
        accommodation_type?: string;
        /**
         * уровень сложности
         */
        activity_level_category?: string;
        /**
         * Разрешено ли с детьми
         */
        children_allowed?: boolean;
        /**
         * slug города
         */
        city__slug?: string;
        /**
         * уровень комфорта
         */
        comfort_type?: string;
        /**
         * slug страны
         */
        country__slug?: string;
        /**
         * Валюта отображения цен
         */
        display_currency?: string;
        /**
         * длительность экскурсии (интервал)
         */
        duration_interval?: string;
        /**
         * дата "по" включительно в формате YYYY-MM-DD
         */
        end_date?: string;
        /**
         * максимальная длительность (в часах)
         */
        end_duration?: number;
        /**
         * максимальная стоимость
         */
        end_price?: number;
        /**
         * фильтр по формату экспириенса (experience/activity/waterwalk/photosession/etc.)
         */
        exp_format?: string;
        /**
         * фильтр по типу передвижения (foot/car/bicycle/watership/etc.)
         */
        movement_type?: string;
        /**
         * фильтр по приостановленным экспириенсам
         */
        paused?: string;
        /**
         * Количество людей
         */
        persons_count?: number;
        /**
         * формат цены
         */
        price_format: 'travelers';
        /**
         * slug региона
         */
        region__slug?: string;
        /**
         * дата "от" включительно в формате YYYY-MM-DD
         */
        start_date?: string;
        /**
         * минимальная длительность (в часах)
         */
        start_duration?: number;
        /**
         * минимальная стоимость
         */
        start_price?: number;
        /**
         * временной интервал экскурсии
         */
        start_time_interval?: string;
        /**
         * bilety-v-muzei
         */
        tag__slugs?: string;
        /**
         * фильтр по типу активности (pohod/splav/ski-and-snowboard/yahting/etc.)
         */
        tour_activity_slugs?: string;
        /**
         * формат экскурсий
         */
        type?: string;
    };
};

export type GetExperiencesCountResponse2 = (GetExperiencesCountResponse);

export type GetExperiencesCountError = unknown;

export type GetRelatedExperiencesData = {
    query?: {
        /**
         * Тип доступности
         */
        bookable?: boolean;
        /**
         * Slug города
         */
        city__slug?: string;
        /**
         * Валюта отображения цен
         */
        display_currency?: string;
        /**
         * включить эксперимент с подборками-рубриками на листинге (true/false, default=false)
         */
        experiment_related_tags?: boolean;
        /**
         * Номер страницы
         */
        page?: number;
        /**
         * Количество людей
         */
        persons_count?: number;
        /**
         * кол-во фотографий
         */
        photos_count?: number;
        /**
         * Формат цены
         */
        price_format?: string;
        /**
         * Тип экспириенсов
         */
        type?: string;
    };
};

export type GetRelatedExperiencesResponse2 = (GetRelatedExperiencesResponse);

export type GetRelatedExperiencesError = unknown;

export type AddExperienceToFavoritesData = {
    path: {
        /**
         * ID experience
         */
        id: number;
    };
};

export type AddExperienceToFavoritesResponse = ({
    item_id: number;
    dt_created: Date;
    city_fk_id: number;
});

export type AddExperienceToFavoritesError = (unknown);

export type RemoveExperienceFromFavoritesData = {
    path: {
        /**
         * ID experience
         */
        id: number;
    };
};

export type RemoveExperienceFromFavoritesResponse = (void);

export type RemoveExperienceFromFavoritesError = (unknown);

export type GetFavoriteExperiencesData = {
    query?: {
        /**
         * Список ID experience через запятую
         */
        ids?: string;
    };
};

export type GetFavoriteExperiencesResponse = ({
    data: Array<{
        item_id: number;
        dt_created: Date;
        city_fk_id: number;
    }>;
    request?: {
        [key: string]: unknown;
    };
    response?: {
        [key: string]: unknown;
    };
});

export type GetFavoriteExperiencesError = (unknown);

export type GetCitiesToursByRegionData = {
    path: {
        regionSlug: string;
    };
};

export type GetCitiesToursByRegionResponse2 = (GetCitiesToursByRegionResponse);

export type GetCitiesToursByRegionError = unknown;

export type GetCalendarEventsChipsResponse2 = (GetCalendarEventsChipsResponse);

export type GetCalendarEventsChipsError = unknown;

export type GetDisplayCurrenciesResponse = (Array<DisplayCurrency>);

export type GetDisplayCurrenciesError = unknown;

export type AddExperienceToFavoritesResponseTransformer = (data: any) => Promise<AddExperienceToFavoritesResponse>;

export const AddExperienceToFavoritesResponseTransformer: AddExperienceToFavoritesResponseTransformer = async (data) => {
    if (data?.dt_created) {
        data.dt_created = new Date(data.dt_created);
    }
    return data;
};